import { render, staticRenderFns } from "./ClaimPaymentEdit.vue?vue&type=template&id=5008d4b2&scoped=true&"
import script from "./ClaimPaymentEdit.vue?vue&type=script&lang=js&"
export * from "./ClaimPaymentEdit.vue?vue&type=script&lang=js&"
import style0 from "./ClaimPaymentEdit.vue?vue&type=style&index=0&id=5008d4b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5008d4b2",
  null
  
)

export default component.exports